/**
 * 21. Role Configuration (Per central_oauth.pdf)
 * Maps roles to landing routes, sidebar visibility, and allowed route patterns.
 */
export const rolesConfig = {
  // Industrial Domain Roles
  super_admin: {
    landingRoute: "/dashboard",
    showSidebar: true,
    allowedRoutes: ["*"],
  },
  Admin: {
    landingRoute: "/dashboard",
    showSidebar: true,
    allowedRoutes: ["*"],
  },
  plant_manager: {
    landingRoute: "/dashboard",
    showSidebar: true,
    allowedRoutes: [
      "/dashboard",
      "/plants",
      "/machines",
      "/machines/*",
      "/sops",
      "/sops/*",
      "/maintenance",
      "/maintenance/*",
      "/errors",
      "/errors/*",
      "/assistant",
      "/knowledge",
      "/knowledge/*",
      "/predictive",
      "/training",
      "/workflows",
      "/settings",
    ],
  },
  quality_officer: {
    landingRoute: "/dashboard",
    showSidebar: true,
    allowedRoutes: [
      "/dashboard",
      "/plants",
      "/machines",
      "/machines/*",
      "/sops",
      "/sops/*",
      "/maintenance",
      "/maintenance/*",
      "/errors",
      "/errors/*",
      "/assistant",
      "/settings",
    ],
  },
  ai_admin: {
    landingRoute: "/knowledge",
    showSidebar: true,
    allowedRoutes: [
      "/dashboard",
      "/plants",
      "/knowledge",
      "/knowledge/*",
      "/predictive",
      "/training",
      "/workflows",
      "/assistant",
      "/settings",
    ],
  },
  maintenance_technician: {
    landingRoute: "/maintenance",
    showSidebar: true,
    allowedRoutes: [
      "/dashboard",
      "/plants",
      "/machines",
      "/machines/:id",
      "/sops",
      "/sops/:id",
      "/maintenance",
      "/maintenance/:id",
      "/maintenance/:id/execute",
      "/errors/report",
      "/assistant",
      "/settings",
    ],
  },
  machine_operator: {
    landingRoute: "/dashboard",
    showSidebar: true,
    allowedRoutes: [
      "/dashboard",
      "/plants",
      "/machines",
      "/machines/:id",
      "/sops",
      "/sops/:id",
      "/maintenance",
      "/maintenance/:id",
      "/maintenance/:id/execute",
      "/errors/report",
      "/assistant",
      "/settings",
    ],
  },
  Tester: {
    landingRoute: "/dashboard",
    showSidebar: true,
    allowedRoutes: ["*"],
  },
  Viewer: {
    landingRoute: "/dashboard",
    showSidebar: false,
    allowedRoutes: ["/dashboard", "/plants", "/machines", "/machines/:id", "/sops", "/sops/:id"],
  },
};
